import { OptionType } from '@/shared/api/BaseAPI.model'
import { z } from 'zod'

export const buildSyncFieldsValidationSchema = (options: OptionType[]) =>
  z.object(
    options.reduce(
      (acc, lang) => {
        acc[lang.value] = z.string().trim().min(1)
        return acc
      },
      {} as Record<string, z.ZodString>
    )
  )
